/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';

//@ts-ignore
import { DashboardSquare02StrokeRounded,Settings02StrokeRounded,ArrowLeftRightStrokeRounded,ConnectStrokeRounded,  CustomerService01Icon,Chart02Icon,AiUserStrokeRounded     } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import {DashboardSquare02DuotoneRounded,Chart02Icon as Chart02IcoDuotone, AiUserIcon,Settings02DuotoneRounded,ConnectDuotoneRounded } from '@hugeicons-pro/core-duotone-rounded';
//@ts-ignore
import { DocumentCodeIcon, SentIcon as SentIconStroke,} from '@hugeicons-pro/core-stroke-standard';  
//@ts-ignore
import { SentIcon as SentIconDuotone} from '@hugeicons-pro/core-duotone-standard';
import {MailOpenstrokeRounded,MailOpenDuotoneRounded} from '../common/icons/customIcons';
import type {MenuItem} from './types/types';

export const MenuItems: MenuItem[] = [
  {
    id: 1,
    label: 'Dashboard',
    rightCode: "DASHBOARD",
    icon: <HugeiconsIcon
    icon={DashboardSquare02StrokeRounded}
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon: <HugeiconsIcon
    icon={DashboardSquare02DuotoneRounded}
    size={18}
    color="inherit"
    strokeWidth={0.2}
  />,
    link: '/dashboard'
  },
  {
    id: 2,
    rightCode: "TEMPLATE",
    icon: <MailOpenstrokeRounded 
    color="currentColor"
    strokeWidth={0.2}/>,
    activeIcon: <MailOpenDuotoneRounded color="inherit"
    strokeWidth={0.2} />,
    link: '/template'
  },
  {
    id: 3,
    rightCode: 'MCAMPAIGN',
    icon: <HugeiconsIcon
    icon={SentIconStroke}
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon:  <HugeiconsIcon
    icon={SentIconDuotone}
    size={18}
    color="inherit"
    strokeWidth={0.2}
  />,
    link: '/campaigns',
    subMenu: [
      {
        id: 11,
        link: '/campaigns',
        rightCode:'CAMPAIGN'
      },
      {
        id: 12,
        link: '/trigger',
        rightCode:'LISTTRIGGER'
      },
      {
        id: 13,
        link: '/bulk-email',
        rightCode:'BULKEMAIL'
      },
    ],
  },
  {
    id: 4,
    rightCode:'API_WEBHOOKS',
    icon: <HugeiconsIcon
    icon={ArrowLeftRightStrokeRounded}
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon: <HugeiconsIcon
    icon={ArrowLeftRightStrokeRounded}
    size={18}
    color="inherit"
    strokeWidth={0.2}
  />,
    link: '/apiandwebhooks',
    subMenu: [
      {
        id: 21,
        link: '/apiandwebhooks/manage-api',
        rightCode:'API_TOKEN'
      },
      {
        id: 22,
        link: '/apiandwebhooks/manage-webhooks',
        rightCode:'WEBHOOKS'
      },
    ],
  },
  {
    id: 5,
    rightCode:'REPORTS',
    icon: <HugeiconsIcon
    icon={Chart02Icon }
    size={18}
    color="currentColor"
    strokeWidth={0.1}
  />,
    activeIcon:<HugeiconsIcon
    icon={Chart02IcoDuotone }
    size={18}
    color="inherit"
    strokeWidth={0.1}
  />,
    link: '/reports',
    subMenu: [
      {
        id: 31,
        link: '/reports/billing-report',
        rightCode:'BILL_REPORT'
      },
      //  {
      //   id: 32,
      //   link: '/reports/testemailsend-report',
      //   rightCode:'TESTEMAIL_REPORT'
      // },
      {
        id: 33,
        link: '/reports/bounce-report',
        rightCode:'BOUNCE_REPORT'
      },
      {
        id: 34,
        link: '/reports/campaign-schedule',
        rightCode:'CAMPAIGN_SCHEDULE'
      }
    ],
  },
  {
    id: 6,
    rightCode:'SETTINGS',
    icon: <HugeiconsIcon
    icon={Settings02StrokeRounded}
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon:<HugeiconsIcon
    icon={Settings02DuotoneRounded}
    size={18}
    color="inherit"
    strokeWidth={0.2}
  />,
    link: '/settings',
    subMenu: [
      {
        id: 45,
        link: '/brandsandgroups/manage-groups',
        rightCode:'GROUPS'
      },
      {
        id: 46,
        link: '/brandsandgroups/manage-brands',
        rightCode:'BRANDS'
      },
      {
        id: 47,
        link: '/seed-list',
        rightCode:'SEEDLIST'
      },
      {
        id: 48,
        link: '/suppression-list',
        rightCode:'SUPPRESSIONLIST'
      },
      {
        id: 49,
        link: '/unsubscribe-list',
        rightCode:'UNSUBSCRIBELIST'
      },
    ],
  },
  {
    id: 7,
    rightCode:'ADMIN',
    icon: <HugeiconsIcon
    icon={AiUserStrokeRounded }
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon:<HugeiconsIcon
    icon={AiUserIcon}
    size={18}
    color="inherit"
    strokeWidth={0.2}
  />,
    link: '/admin',
    subMenu: [
      {
        id: 41,
        link: '/admin/manage-users',
        rightCode:'USERS'
      },
      {
        id: 42,
        link: '/admin/manage-roles',
        rightCode:'ROLES'
      },
      {
        id: 43,
        link: '/admin/manage-clients',
        rightCode:'CLIENTS'
      },
      {
        id: 44,
        link: '/admin/manage-appconfig',
        rightCode:'APPCONFIG'
      },
    ],
  },
  {
    id: 7,
    rightCode:'ESP',
    icon: <HugeiconsIcon
    icon={ConnectStrokeRounded}
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon:<HugeiconsIcon
    icon={ConnectDuotoneRounded}
    size={18}
    color="inherit"
    strokeWidth={0.2}
  />,
  
    link: '/email-api',
  },
  {
    id: 8,
    label: 'API Docs',
    rightCode: "APIDOC",
    icon: <HugeiconsIcon
    icon={DocumentCodeIcon}
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon: <HugeiconsIcon
    icon={DocumentCodeIcon}
    size={18}
    color="inherit"
    strokeWidth={0.2}
  />,
    link: 'https://developers.healthlinkdimensions.com/reference/trigger-email-api'
  },
  {
    id: 9,
    label: 'Support',
    rightCode: "SUPPORT",
    icon: <HugeiconsIcon
    icon={CustomerService01Icon}
    size={18}
    color="currentColor"
    strokeWidth={0.2}
  />,
    activeIcon: <HugeiconsIcon
    icon={CustomerService01Icon}
    size={18}
    color="inherit"
    strokeWidth={0.2}
  />,
    link: 'https://support.tickets.healthlinkdimensions.com/servicedesk/customer/portal/5/group/21'
  },
];